import Video from '@atoms/Video/Video';
import Section from '@molecules/Section/Section';
import SectionContent from '@molecules/Section/SectionContent';
import { VideoSection as Props } from '@type-declarations/sections';
import clsx from 'clsx';

import styles from './VideoSection.module.scss';

function VideoSection({
  title,
  subtitle,
  text,
  cta,
  backgroundColor,
  video,
  fullWidth,
  modifier,
}: Props) {
  if (!video?.embeddedVideo?.playbackId && !video?.youtubeId) {
    return null;
  }

  return (
    <Section backgroundColor={backgroundColor.color}>
      <SectionContent
        title={title}
        subtitle={subtitle}
        text={text}
        cta={cta}
        className={styles.content}
        centered
        modifier={modifier === 'inStore' ? 'inStore' : undefined}
      />

      <Video
        video={video}
        className={clsx(styles.video, fullWidth && styles.fullWidth)}
      />
    </Section>
  );
}

export default VideoSection;
